"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_VARIANTS = exports.UPDATE_RENDER_PROPS = exports.UPDATE_PRE_DEFINED_MESSAGE_USED = exports.UPDATE_PARTNERS_BLOCKED = exports.UPDATE_PARTNERS = exports.UPDATE_LIST_POSITION = exports.UPDATE_CHAT_MESSAGES_LOADED = exports.UPDATE_CHAT_LAST_SEEN = exports.UPDATE_ACTIVE_TAB = exports.UI = exports.STOP_WATCHING_PARTNERS = exports.STOP_TYPING = exports.START_WATCHING_PARTNERS = exports.START_TYPING = exports.SHOW_OLXPAY_BUYER_BUTTONS = exports.REMOVE_CHAT = exports.RECEIVE_STANZAS = exports.RECEIVE_MESSAGES = exports.RECEIVE_CHATS = exports.REASON = exports.PARTNERS_STATUS = exports.MODAL_TYPE = exports.MODAL = exports.MESSAGE_UNKNOWN_ERROR = exports.LOAD_WALLET_BUTTON_SUCCESSFUL = exports.LOAD_WALLET_BUTTON_ERROR = exports.LOAD_CHAT_START = exports.LOAD_CHAT_ERROR = exports.LOAD_CHAT_DONE = exports.LOAD_CHATS_START = exports.LOAD_CHATS_ERROR = exports.LOAD_CHATS_DONE = exports.KEYBOARD = exports.JOIN_ROOM_START = exports.JOIN_ROOM_ERROR = exports.JOIN_ROOM_DONE = exports.IMAGE_LOADING_SUCCESSFUL = exports.IMAGE_LOADING_START = exports.IMAGE_LOADING_FAILED = exports.HIDE_MESSAGES = exports.FAVORITE_CHAT = exports.ENABLE_WALLET_BUTTON = exports.DISABLE_WALLET_BUTTON = exports.CHAT_UNKNOWN_ERROR = exports.CHANGE_CURRENT_CHAT_POSITION = exports.CHANGE_CURRENT_CHAT = exports.ADD_NOTIFICATION_TYPE = exports.ADD_BUTTONS = void 0;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LOAD_CHAT_START = exports.LOAD_CHAT_START = 'LOAD_CHAT_START';
var LOAD_CHAT_DONE = exports.LOAD_CHAT_DONE = 'LOAD_CHAT_DONE';
var LOAD_CHAT_ERROR = exports.LOAD_CHAT_ERROR = 'LOAD_CHAT_ERROR';
var JOIN_ROOM_START = exports.JOIN_ROOM_START = 'JOIN_ROOM_START';
var JOIN_ROOM_DONE = exports.JOIN_ROOM_DONE = 'JOIN_ROOM_DONE';
var JOIN_ROOM_ERROR = exports.JOIN_ROOM_ERROR = 'JOIN_ROOM_ERROR';
var RECEIVE_MESSAGES = exports.RECEIVE_MESSAGES = 'RECEIVE_MESSAGES';
var HIDE_MESSAGES = exports.HIDE_MESSAGES = 'HIDE_MESSAGES';
var REMOVE_CHAT = exports.REMOVE_CHAT = 'REMOVE_CHAT';
var ADD_BUTTONS = exports.ADD_BUTTONS = 'ADD_BUTTONS';
var ADD_NOTIFICATION_TYPE = exports.ADD_NOTIFICATION_TYPE = 'ADD_NOTIFICATION_TYPE';
var CHANGE_CURRENT_CHAT = exports.CHANGE_CURRENT_CHAT = 'CHANGE_CURRENT_CHAT';
var CHANGE_CURRENT_CHAT_POSITION = exports.CHANGE_CURRENT_CHAT_POSITION = 'CHANGE_CURRENT_CHAT_POSITION';
var RECEIVE_CHATS = exports.RECEIVE_CHATS = 'RECEIVE_CHATS';
var RECEIVE_STANZAS = exports.RECEIVE_STANZAS = 'RECEIVE_STANZAS';
var UPDATE_PARTNERS = exports.UPDATE_PARTNERS = 'UPDATE_PARTNERS';
var UPDATE_PARTNERS_BLOCKED = exports.UPDATE_PARTNERS_BLOCKED = 'UPDATE_PARTNERS_BLOCKED';
var START_WATCHING_PARTNERS = exports.START_WATCHING_PARTNERS = 'START_WATCHING_PARTNERS';
var STOP_WATCHING_PARTNERS = exports.STOP_WATCHING_PARTNERS = 'STOP_WATCHING_PARTNERS';
var UPDATE_CHAT_LAST_SEEN = exports.UPDATE_CHAT_LAST_SEEN = 'UPDATE_CHAT_LAST_SEEN';
var UPDATE_CHAT_MESSAGES_LOADED = exports.UPDATE_CHAT_MESSAGES_LOADED = 'UPDATE_CHAT_MESSAGES_LOADED';
var UPDATE_PRE_DEFINED_MESSAGE_USED = exports.UPDATE_PRE_DEFINED_MESSAGE_USED = 'UPDATE_PRE_DEFINED_MESSAGE_USED';
var LOAD_CHATS_ERROR = exports.LOAD_CHATS_ERROR = 'LOAD_CHATS_ERROR';
var LOAD_CHATS_DONE = exports.LOAD_CHATS_DONE = 'LOAD_CHATS_DONE';
var LOAD_CHATS_START = exports.LOAD_CHATS_START = 'LOAD_CHATS_START';
var START_TYPING = exports.START_TYPING = 'START_TYPING';
var STOP_TYPING = exports.STOP_TYPING = 'STOP_TYPING';
var UPDATE_LIST_POSITION = exports.UPDATE_LIST_POSITION = 'UPDATE_LIST_POSITION';
var UPDATE_RENDER_PROPS = exports.UPDATE_RENDER_PROPS = 'UPDATE_RENDER_PROPS';
var UPDATE_VARIANTS = exports.UPDATE_VARIANTS = 'UPDATE_VARIANTS';
var CHAT_UNKNOWN_ERROR = exports.CHAT_UNKNOWN_ERROR = 'CHAT_UNKNOWN_ERROR';
var MESSAGE_UNKNOWN_ERROR = exports.MESSAGE_UNKNOWN_ERROR = 'MESSAGE_UNKNOWN_ERROR';
var IMAGE_LOADING_START = exports.IMAGE_LOADING_START = 'IMAGE_LOADING_START';
var IMAGE_LOADING_SUCCESSFUL = exports.IMAGE_LOADING_SUCCESSFUL = 'IMAGE_LOADING_SUCCESSFUL';
var IMAGE_LOADING_FAILED = exports.IMAGE_LOADING_FAILED = 'IMAGE_LOADING_FAILED';
var LOAD_WALLET_BUTTON_SUCCESSFUL = exports.LOAD_WALLET_BUTTON_SUCCESSFUL = 'LOAD_WALLET_BUTTON_SUCCESSFUL';
var LOAD_WALLET_BUTTON_ERROR = exports.LOAD_WALLET_BUTTON_ERROR = 'LOAD_WALLET_BUTTON_ERROR';
var DISABLE_WALLET_BUTTON = exports.DISABLE_WALLET_BUTTON = 'DISABLE_WALLET_BUTTON';
var ENABLE_WALLET_BUTTON = exports.ENABLE_WALLET_BUTTON = 'ENABLE_WALLET_BUTTON';
var SHOW_OLXPAY_BUYER_BUTTONS = exports.SHOW_OLXPAY_BUYER_BUTTONS = 'SHOW_OLXPAY_BUYER_BUTTONS';
var FAVORITE_CHAT = exports.FAVORITE_CHAT = 'FAVORITE_CHAT';
var UPDATE_ACTIVE_TAB = exports.UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB';
var REASON = exports.REASON = {
  EXPIRED_AD: 'EXPIRED_AD',
  CHAT_DISABLED: 'CHAT_DISABLED',
  USER_AD: 'USER_AD',
  USER_NOT_LOGGED: 'USER_NOT_LOGGED',
  USER_NOT_IDENTIFIED: 'USER_NOT_IDENTIFIED',
  NO_INTERNET: 'NO_INTERNET',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  UNVERIFIED_PHONE: 'UNVERIFIED_PHONE'
};
var UI = exports.UI = _objectSpread(_objectSpread({}, REASON), {}, {
  LOADING: 'LOADING',
  LIST_MESSAGES: 'LIST_MESSAGES',
  LIST_CHATS: 'LIST_CHATS',
  FOCUS_CHAT_INPUT: 'FOCUS_CHAT_INPUT',
  NOT_AVAILABLE: 'NOT_AVAILABLE'
});
var MODAL = exports.MODAL = {
  OPEN: 'OPEN_MODAL',
  CLOSE: 'CLOSE_MODAL'
};
var KEYBOARD = exports.KEYBOARD = {
  OPEN: 'OPEN_KEYBOARD',
  CLOSE: 'CLOSE_KEYBOARD'
};
var MODAL_TYPE = exports.MODAL_TYPE = {
  RISE: 'RISE',
  FADE: 'FADE'
};
var PARTNERS_STATUS = exports.PARTNERS_STATUS = {
  BLOCKED: 'BLOCKED',
  DENOUNCED: 'DENOUNCED',
  BANNED: 'BANNED',
  VALID: 'VALID',
  VALIDATING_PROFILE: 'VALIDATING_PROFILE'
};